import { createNanoEvents } from "nanoevents";

export const ScreenerGridEmitter = createNanoEvents<{
  exportAs: (format: "csv" | "xlsx", token: string) => void;
}>();
